export interface GenerateReportRowIdInput {
  prefix: string;
  filters?: string[];
}

export const generateReportRowId = ({ prefix, filters = [] }: GenerateReportRowIdInput): string =>
  [prefix, ...filters].join('_');
